module.exports = __webpack_public_path__ + "img/fi-rr-align-justify.14125a86.svg";